export default __webpack_public_path__ + "guide-close9be28d.png";